// extracted by mini-css-extract-plugin
module.exports = {"Copyright":"Copyright_Copyright__32wBi","LogoFooter":"Copyright_LogoFooter__3KHiq"};